// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"fef613f0","408":"dabb4982","476":"09f243b3","495":"0d19fea0","580":"48e0e0ef","631":"f610a49e","696":"88028be3","876":"28d4a70a","981":"fd3bbb33"}[chunkId] + ".chunk.js";
};